import {useMemo} from 'react';

import type {RunHistoryKeyType} from '../../../../types/run';
import {useExistingPanelsByKey} from './useExistingPanelsByKey';
import {useSearchedKeys, useSearchedKeysPaginated} from './useSearchedKeys';

export const useQuickAddKeys = (
  searchStr = '',
  keyType?: RunHistoryKeyType
) => {
  const searchedKeys = useSearchedKeys(searchStr, keyType);
  const existingPanels = useExistingPanelsByKey();
  const keysWithNoPanels = useMemo(
    () =>
      searchedKeys.filter(([key]) => !existingPanels.global.get(key)?.length),
    [searchedKeys, existingPanels]
  );
  return {
    searchedKeys,
    existingPanels,
    keysWithNoPanels,
  };
};

export const useQuickAddKeysPaginated = (
  searchStr = '',
  cursor: string | null = null,
  pageSize = 100
) => {
  const existingPanels = useExistingPanelsByKey();
  const searchedKeys = useSearchedKeysPaginated(searchStr, cursor, pageSize);

  const keysWithNoPanels = useMemo(() => {
    return searchedKeys.keys.filter(
      ([key]) => !existingPanels.global.get(key)?.length
    );
  }, [searchedKeys, existingPanels]);

  return {
    searchedKeys,
    existingPanels,
    keysWithNoPanels,
  };
};
